import { useState } from 'react';

/**
 * Dialog state shared by the profile list sections (work experience, education,
 * expertise): one form used for both adding and editing, plus a delete
 * confirmation. The form is keyed on `isFormOpen` rather than on `editing`, so
 * that adding a record — where there is nothing to edit — still opens it.
 */
export const useRecordDialogs = <T>() => {
    const [editing, setEditing] = useState<T | null>(null);
    const [deleting, setDeleting] = useState<T | null>(null);
    const [isFormOpen, setIsFormOpen] = useState(false);

    const openAddForm = () => {
        setEditing(null);
        setIsFormOpen(true);
    };

    const openEditForm = (record: T) => {
        setEditing(record);
        setIsFormOpen(true);
    };

    return {
        editing,
        deleting,
        isFormOpen,
        openAddForm,
        openEditForm,
        askToDelete: setDeleting,
        closeForm: () => setIsFormOpen(false),
        cancelDelete: () => setDeleting(null),
    };
};
